export default __webpack_public_path__ + "static/media/about.5723fe32.png";